
import { useEffect } from 'react';
import { useSiteSettings } from './useSiteSettings';

export const useFavicon = () => {
  const { settings, loading } = useSiteSettings();

  useEffect(() => {
    if (loading) return;

    // Remover favicon existente
    const existingFavicon = document.querySelector('link[rel="icon"]') || 
                           document.querySelector('link[rel="shortcut icon"]');
    
    if (existingFavicon) {
      existingFavicon.remove();
    }

    // Agregar nuevo favicon si existe URL
    if (settings.faviconUrl) {
      const link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/x-icon';
      link.href = settings.faviconUrl;
      document.head.appendChild(link);
    }
  }, [settings.faviconUrl, loading]);

  return { faviconUrl: settings.faviconUrl, loading };
};
